import React from 'react';
import { Menu as LucideMenu } from 'lucide-react';

interface MenuProps {
  width?: number;
  height?: number;
  className?: string;
  style?: React.CSSProperties;
}

const Menu: React.FC<MenuProps> = ({ width = 24, height = 24, className, style }) => (
  <LucideMenu width={width} height={height} className={className} style={style} aria-hidden strokeWidth={2} />
);

export default Menu;
